import { formatDate, ListProviderGuarantorsRequest, ProviderGuarantor } from '@enter/core';
import * as faker from 'faker';
import _ from 'lodash';
import { IItemDetail, IItemListing } from './root.store';
import { waitForNoReason } from './util';
import { generateAddress, generateItemListing } from './util.generator';

export class GuarantorGenerator {
    public guarantors: ProviderGuarantor[] = [];

    // TODO: extract index/storeTo/loadFrom as utility class
    public index: Map<string, Map<string, string[]>> = new Map<string, Map<string, string[]>>();

    constructor() {
        this.generateEntities(11);
    }

    public async loadGuarantorListing(
        lpgr: ListProviderGuarantorsRequest,
    ): Promise<IItemListing<ProviderGuarantor> | undefined> {
        await waitForNoReason(400);
        return generateItemListing(lpgr, this.guarantors);
    }
    public async loadGuarantor(chargemasterId: string): Promise<ProviderGuarantor | undefined> {
        let chargemaster = _.find(this.guarantors, { id: chargemasterId });
        if (!chargemaster) {
            chargemaster = this.generateProviderGuarantor(chargemasterId);
        }
        return chargemaster;
    }
    public async loadGuarantorDetail(id: string): Promise<IItemDetail<ProviderGuarantor> | undefined> {
        return undefined;
    }

    private generateEntities(count: number = 3): void {
        _.times(count, () => this.generateProviderGuarantor());
    }

    private generateProviderGuarantor(id: string = faker.random.uuid()): ProviderGuarantor {
        const guarantor = {
            id,
            created: formatDate('Date')(faker.date.past()),
            organization: faker.company.companyName(),
            first: faker.name.firstName(),
            middle: _.sample([undefined, faker.name.firstName()]),
            last: faker.name.lastName(),
            suffix: _.sample([undefined, faker.name.suffix()]),
            addresses: _.times(_.random(0, 2), () => generateAddress()),
            phone: faker.phone.phoneNumber(),
            dob: formatDate('Date')(faker.date.past()),
            email: faker.internet.exampleEmail(),
            groupId: _.uniqueId('group'),
        };
        this.guarantors.push(guarantor);
        return guarantor;
    }

    private storeToIndex<T>(model: string, key: string, values: T | T[]): void {
        if (!this.index.has(model)) {
            this.index.set(model, new Map<string, string[]>());
        }
        const array = _.get(this, model);
        const index = this.index.get(model);
        if (array && index) {
            const items = _.concat([], values);
            const oldIds = index.get(key) || [];
            const newIds = _.map(items, 'id');
            index.set(key, [...oldIds, ...newIds]);
            items.forEach(item => array.indexOf(item) === -1 && array.push(item));
        }
    }

    private loadFromIndex<T>(model: string, key: string): T[] | undefined {
        const array = _.get(this, model);
        const index = this.index.get(model);
        if (array && index) {
            const ids = index.get(key);
            return _.filter(array, (item: T): boolean => _.includes(ids, _.get(item, 'id')));
        }
    }
}
